import { RESIZE_PANEL_SLIDE_TIMING } from '@affine/component/resize-panel';
import { useLayoutEffect } from 'react';

import type { View, ViewEndCover } from '../entities/view';

/** An overlay sidebar lies over the last view's end. The sidebar tells that view how wide it covers,
 * from the width it renders, so what floats over the view (the AI island) follows a resize while
 * it is dragged, not only after the width is stored. The other views are not covered. */
export function useSidebarCover(
  views: readonly View[],
  coverWidth: number,
  dragged: boolean
) {
  useLayoutEffect(() => {
    const last = views.at(-1);
    for (const view of views) {
      view.endCover$.next(
        view === last
          ? { width: coverWidth, dragged }
          : { width: 0, dragged: false }
      );
    }
  }, [coverWidth, dragged, views]);
}

/** How what follows the cover moves: with the sidebar's slide, or with each frame of a drag. */
export const endCoverTiming = (cover: ViewEndCover) =>
  cover.dragged ? '0s' : RESIZE_PANEL_SLIDE_TIMING;
